import { tBillPayModel } from './tBillPayModel';

export class tShoppingCartModel extends tBillPayModel {
}

export class tShoppingCartModelWithItemCateInfo extends tShoppingCartModel {
    itemCateID: string;
    itemCateIsService: string;
    specialPaymentType: number;
    isNegativeQty:string;
}
